import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/vcicon.svg'
import _imports_1 from '@/assets/icons/openlistdetails.svg'
import _imports_2 from '@/assets/icons/pagefirstenabled.svg'
import _imports_3 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_4 from '@/assets/icons/pagelastenabled.svg'
import _imports_5 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = {
  key: 0,
  class: "subscontent"
}
const _hoisted_2 = { class: "celldiv" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cellimage",
  alt: "vciconimg",
  title: "vciconimg"
}, null, -1)
const _hoisted_4 = { class: "celltext" }
const _hoisted_5 = { style: {"margin":"unset"} }
const _hoisted_6 = { style: {"font-weight":"700"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"25px"},
  alt: "listdetailsimg",
  title: "listdetailsimg"
}, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "usermodalpagingdiv"
}
const _hoisted_9 = { class: "pagelabel" }
const _hoisted_10 = {
  key: 0,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "firstpageimg",
  title: "firstpageimg"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "firstpagedisabledimg",
  title: "firstpagedisabledimg"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "lastpageimg",
  title: "lastpageimg"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_5,
  style: {"width":"20px"},
  alt: "lastpagedisabledimg",
  title: "lastpagedisabledimg"
}
const _hoisted_14 = {
  key: 1,
  class: "accdiv"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "prdtext" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "accprd" }, "Credential-based Products")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "prdtextdetail" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "labeltext" }, "All manageable credential-based products from your administered companies")
], -1)
const _hoisted_17 = { class: "carddeck" }
const _hoisted_18 = { class: "subaccprddiv" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"55px","margin-right":"20px"},
  alt: "vciconimg",
  title: "vciconimg"
}, null, -1)
const _hoisted_20 = { style: {"text-align":"start","display":"flex","flex-direction":"column"} }
const _hoisted_21 = { class: "accprd" }
const _hoisted_22 = { class: "subdatadiv" }
const _hoisted_23 = { class: "subseat" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "labeltext" }, "Seats used: ", -1)
const _hoisted_25 = { class: "accprd" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.showsub)
    ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
        default: _withCtx(() => [
          (!_ctx.showCards)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  id: "subscriptionslisttable",
                  data: _ctx.subscriptionList,
                  style: {"width":"100%"},
                  "max-height": "600",
                  "scrollbar-always-on": "",
                  "header-cell-style": _ctx.headerstyle,
                  "row-style": _ctx.rowdatastyle,
                  onRowClick: _ctx.rowClickHandler,
                  "empty-text": "No credential-based products available"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Product Name",
                      prop: "productName",
                      "label-class-name": "labelpadding",
                      "min-width": "150"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_2, [
                          _hoisted_3,
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("label", _hoisted_5, _toDisplayString(props.row.productName.substring(0, 18)), 1),
                            _createElementVNode("label", _hoisted_6, _toDisplayString(props.row.productName.substring(18)), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Version",
                      align: "center"
                    }, {
                      default: _withCtx((props) => [
                        _createTextVNode(_toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Product Seats",
                      align: "center"
                    }, {
                      default: _withCtx((props) => [
                        _createTextVNode(_toDisplayString(props.row.seatsUsed) + "/" + _toDisplayString(props.row.seats), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Add-on",
                      align: "center",
                      prop: "addOns"
                    }, {
                      default: _withCtx((props) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.productName), 1))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Add-on Seats",
                      align: "center"
                    }, {
                      default: _withCtx((props) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.seatsUsed) + "/" + _toDisplayString(addon.seats), 1))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      align: "center",
                      label: "",
                      width: "150"
                    }, {
                      default: _withCtx((subcription) => [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (_ctx.viewDetails(subcription.row)),
                          plain: "",
                          link: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "header-cell-style", "row-style", "onRowClick"])), [
                  [_directive_loading, _ctx.loading]
                ]),
                (_ctx.totalPages > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, [
                        _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
                      ]),
                      _createVNode(_component_el_button, {
                        plain: "",
                        class: "paginationbtn",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentPage = 1)),
                        id: "firstpage",
                        disabled: _ctx.currentPage === 1
                      }, {
                        default: _withCtx(() => [
                          (_ctx.currentPage !== 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                            : _createCommentVNode("", true),
                          (_ctx.currentPage === 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_pagination, {
                        layout: "prev, next",
                        total: _ctx.totalRowsCount,
                        "page-size": 10,
                        "current-page": _ctx.currentPage,
                        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
                      }, null, 8, ["total", "current-page"]),
                      _createVNode(_component_el_button, {
                        plain: "",
                        class: "paginationbtn",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
                        id: "lastpage",
                        disabled: _ctx.currentPage === _ctx.totalPages
                      }, {
                        default: _withCtx(() => [
                          (_ctx.currentPage !== _ctx.totalPages)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                            : _createCommentVNode("", true),
                          (_ctx.currentPage === _ctx.totalPages)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showCards)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptionList, (prod, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "subcarddiv bottommargin",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", _hoisted_21, _toDisplayString(prod.productName), 1),
                          _createElementVNode("label", null, "Version: " + _toDisplayString(prod.majorVersionNumber) + "." + _toDisplayString(prod.minorVersionNumber), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("h5", _hoisted_25, _toDisplayString(prod.seatsUsed) + "/" + _toDisplayString(prod.seats), 1)
                        ]),
                        _createVNode(_component_el_button, {
                          round: "",
                          class: "slicbtn",
                          id: "viewDetails",
                          type: "warning",
                          onClick: ($event: any) => (_ctx.viewDetails(prod))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Manage ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}